// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deal-taxes-expanded_container__oUkD8 {
    width: var(--container-width);
    padding: 0 var(--container-padding);
    margin: 0 auto;
    position: relative;
    max-width: calc(100% - 60px);
    height: calc(100vh - var(--header-height));
}

.deal-taxes-expanded_pageHeader__0EMRY {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #7b848e;
    /*margin-bottom: 12px;*/
    padding: 25px 0;
}

.deal-taxes-expanded_pageHeader__0EMRY h3 {
    margin: auto 0;
}

.deal-taxes-expanded_sectionWrapper__tLHxE {
    max-height: calc(100vh - var(--header-height) - 150px);
    margin-bottom: 40px;
    padding-right: 10px;
}

.deal-taxes-expanded_btnWrapper__am50n {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DealTaxesExpanded/deal-taxes-expanded.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sDAAsD;IACtD,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".container {\n    width: var(--container-width);\n    padding: 0 var(--container-padding);\n    margin: 0 auto;\n    position: relative;\n    max-width: calc(100% - 60px);\n    height: calc(100vh - var(--header-height));\n}\n\n.pageHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #7b848e;\n    /*margin-bottom: 12px;*/\n    padding: 25px 0;\n}\n\n.pageHeader h3 {\n    margin: auto 0;\n}\n\n.sectionWrapper {\n    max-height: calc(100vh - var(--header-height) - 150px);\n    margin-bottom: 40px;\n    padding-right: 10px;\n}\n\n.btnWrapper {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `deal-taxes-expanded_container__oUkD8`,
	"pageHeader": `deal-taxes-expanded_pageHeader__0EMRY`,
	"sectionWrapper": `deal-taxes-expanded_sectionWrapper__tLHxE`,
	"btnWrapper": `deal-taxes-expanded_btnWrapper__am50n`
};
export default ___CSS_LOADER_EXPORT___;
